import { RegisterTypes } from './types';
import { cleanCnpj } from 'utils/cnpj';

export const fetchCompanyByCnpj = (cnpj: string, email: string) => {
  const clean = cleanCnpj(cnpj);

  return {
    types: [
      RegisterTypes.FETCH_COMPANY_REQUEST,
      RegisterTypes.FETCH_COMPANY_SUCCESS,
      RegisterTypes.FETCH_COMPANY_FAILURE,
    ],
    promise: (client: any) => client.get(`/register/company`, { params: { email, cnpj: clean } }),
  };
};

export const userExists = (email: string) => {
  return {
    types: [
      RegisterTypes.CHECK_EMAIL_REQUEST,
      RegisterTypes.CHECK_EMAIL_SUCCESS,
      RegisterTypes.CHECK_EMAIL_FAILURE,
    ],
    promise: (client: any) => client.get(`/register/exists`, { params: { email } }),
  };
};

export const clearRegister = () => ({
  type: RegisterTypes.CLEAR_REGISTER,
});
